module.exports = __webpack_public_path__ + "static/media/EPITOME_BG.ccaeba3c.jpeg";